import each from 'lodash/each';
import { Breakpoint, createTheme, Theme } from '@mui/material/styles';
import { TypographyPropsVariantOverrides } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import { commonThemeParams, darkThemeParams } from 'assets/theme';

const MEDIA_EDGE = 0;
const pxToRem = (val: number) => {
  return val / 16;
};

export type TypographyVariant = keyof TypographyPropsVariantOverrides | Variant;
type GenerateResponsiveFontsOptions = {
  sizesMap: { [key in TypographyVariant]: number[] | null };
  sortedBp: Readonly<Breakpoint[]>;
};

const generateResponsiveFontsOptions: GenerateResponsiveFontsOptions = {
  sizesMap: {
    f8: [8, 8, 8, 8, 8, 8],
    f10: [10, 10, 9, 9, 10, 10],
    f12: [12, 12, 11, 11, 12, 12],
    f12b: [12, 12, 11, 11, 12, 12],
    f14: [14, 14, 14, 14, 14, 14],
    f14b: [14, 14, 14, 14, 14, 14],
    f16b: [16, 16, 16, 16, 16, 16],
    f24: [24, 24, 18, 20, 22, 24],
    f26: [26, 26, 20, 22, 24, 26],
    h1: null,
    h2: null,
    h3: null,
    h4: null,
    h5: null,
    h6: null,
    subtitle1: null,
    subtitle2: null,
    body1: null,
    body2: null,
    caption: null,
    button: null,
    overline: null,
  },
  // При min-width обязателен порядок по возрастанию!
  sortedBp: [
    'mobile',
    'tablet',
    'laptop',
    'desktop_small',
    'desktop_middle',
    'desktop_large',
  ],
};

const generateResponsiveFonts = (
  theme: Theme,
  { sizesMap, sortedBp }: GenerateResponsiveFontsOptions
) => {
  each(sortedBp, (bp, bpIndex) => {
    const mediaString = theme.breakpoints.up(bp);
    const bpWidth = theme.breakpoints.values[bp];

    if (bpWidth <= MEDIA_EDGE) {
      return;
    }

    // Заглушка от нуля до нижнего брикпоинта
    each(sizesMap, (values, key) => {
      const mediaString = theme.breakpoints.up(0);
      const variant = key as TypographyVariant;

      if (!values) {
        const baseSize = theme.typography[variant].fontSize;
        // @ts-ignore
        theme.typography[variant][mediaString] = {
          fontSize: baseSize,
        };
        return;
      }

      // @ts-ignore
      theme.typography[variant][mediaString] = {
        fontSize: `${pxToRem(values[0])}rem`,
      };
    });

    each(sizesMap, (values, key) => {
      const variant = key as TypographyVariant;

      if (!values) {
        const baseSize = theme.typography[variant].fontSize;
        // @ts-ignore
        theme.typography[variant][mediaString] = {
          fontSize: baseSize,
        };
        return;
      }

      // @ts-ignore
      theme.typography[variant][mediaString] = {
        fontSize: `${pxToRem(values[bpIndex])}rem`,
      };
    });
  });

  return theme;
};

export const constructTheme = () => {
  return generateResponsiveFonts(
    createTheme({ ...darkThemeParams, ...commonThemeParams }),
    generateResponsiveFontsOptions
  );
};
